import { useSiteConfig } from '@/contexts/SiteConfigContext';

export default function WhatsAppButton() {
  const { config } = useSiteConfig();
  const { texts } = config;

  const whatsappNumber = texts.whatsappNumber || '5577999633110';
  const message = encodeURIComponent(
    'Olá! Gostaria de mais informações sobre os imóveis da Ação Negócios Imobiliários.'
  );

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 left-6 z-[999] flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold px-4 py-3 rounded-full shadow-2xl transition-all hover:scale-105 cursor-pointer group"
      style={{ boxShadow: '0 4px 24px rgba(37,211,102,0.45)' }}
    >
      <span className="w-8 h-8 flex items-center justify-center">
        <i className="ri-whatsapp-line text-2xl"></i>
      </span>
      <span className="text-sm whitespace-nowrap max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 ease-in-out">
        Fale conosco
      </span>
    </a>
  );
}